/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from "axios";

import { Expose, Transform, Type, plainToClass } from "class-transformer";

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(
    configs: IRequestConfig,
    resolve: (p: any) => void,
    reject: (p: any) => void
): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error("please inject yourself instance like axios  ");
    }
}

export function getConfigs(
    method: string,
    contentType: string,
    url: string,
    options: any
): IRequestConfig {
    const configs: IRequestConfig = { ...options, method, url };
    configs.headers = {
        ...options.headers,
        "Content-Type": contentType,
    };
    return configs;
}

export const basePath = "";

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class JobExceptionsService {
    /**
     *
     */
    static jobExceptions(
        options: IRequestOptions = {}
    ): Promise<JobExceptionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExceptions";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExceptionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExceptions1(
        params: {
            /** requestBody */
            body?: CreateJobExceptionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExceptionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExceptions";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExceptionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExceptions2(
        params: {
            /** requestBody */
            body?: UpdateJobExceptionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExceptionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExceptions";

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExceptionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExceptions3(
        params: {
            /** requestBody */
            body?: DeleteJobExceptionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExceptionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExceptions";

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExceptionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static job(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExceptionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExceptions/job/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExceptionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExceptions4(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExceptionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExceptions/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExceptionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static exceptionId(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExceptionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExceptions/exceptionID/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExceptionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class JobExecutionsService {
    /**
     *
     */
    static jobExecutions(
        options: IRequestOptions = {}
    ): Promise<JobExecutionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExecutions";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExecutionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExecutions1(
        params: {
            /** requestBody */
            body?: CreateJobExecutionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExecutionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExecutions";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExecutionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExecutions2(
        params: {
            /** requestBody */
            body?: JobCompletedRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExecutionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExecutions";

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExecutionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExecutions3(
        params: {
            /** requestBody */
            body?: DeleteJobExecutionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExecutionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExecutions";

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExecutionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static job(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExecutionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExecutions/job/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExecutionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static jobExecutions4(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobExecutionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/JobExecutions/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(JobExecutionDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class JobsService {
    /**
     *
     */
    static all(
        params: {
            /** requestBody */
            body?: GetJobs;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Jobs/all";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(JobListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static id(
        params: {
            /** requestBody */
            body?: GetJob;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Jobs/id";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(JobDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static create(
        params: {
            /** requestBody */
            body?: MutateJob;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Jobs/create";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(JobDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /** requestBody */
            body?: MutateJob;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Jobs/update";

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(JobDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static delete(
        params: {
            /** requestBody */
            body?: MutateJob;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<JobDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Jobs/delete";

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(JobDetailedResponse, response)),
                reject
            );
        });
    }
}

export class CreateJobExceptionRequest {
    /**  */
    @Expose()
    "id": string;

    /**  */
    "exception": string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["exception"] = data["exception"];
    }

    public static validationModel = {
        id: { required: true },
        exception: { required: true },
    };
}

export class CreateJobExecutionRequest {
    /**  */
    @Expose()
    "id": string;

    /**  */
    "parameters": string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["parameters"] = data["parameters"];
    }

    public static validationModel = {
        id: { required: true },
        parameters: { required: true },
    };
}

export class DeleteJobExceptionRequest {
    /**  */
    @Expose()
    "id"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
    }

    public static validationModel = {};
}

export class DeleteJobExecutionRequest {
    /**  */
    @Expose()
    "id"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
    }

    public static validationModel = {};
}

export class GetJob {
    /**  */
    @Expose()
    "id"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
    }

    public static validationModel = {};
}

export class GetJobs {
    /**  */
    "active"?: boolean;

    /**  */
    @Expose()
    "hostingSource"?: number;

    constructor(data: undefined | any = {}) {
        this["active"] = data["active"];
        this["hostingSource"] = data["hostingSource"];
    }

    public static validationModel = {};
}

export class Job {
    /**  */
    @Expose()
    "id": string;

    /**  */
    "name": string;

    /**  */
    "active": boolean;

    /**  */
    "sourceLocation": string;

    /**  */
    @Expose()
    "hostedType": number;

    /**  */
    @Expose()
    @Type(() => Date)
    "updatedDateTime": Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "createdDateTime": Date;

    /**  */
    @Expose()
    "updatedBy": string;

    /**  */
    @Expose()
    "createdBy": string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["active"] = data["active"];
        this["sourceLocation"] = data["sourceLocation"];
        this["hostedType"] = data["hostedType"];
        this["updatedDateTime"] = data["updatedDateTime"];
        this["createdDateTime"] = data["createdDateTime"];
        this["updatedBy"] = data["updatedBy"];
        this["createdBy"] = data["createdBy"];
    }

    public static validationModel = {
        id: { required: true },
        name: { required: true },
        active: { required: true },
        sourceLocation: { required: true },
        hostedType: { required: true },
        updatedDateTime: { required: true },
        createdDateTime: { required: true },
        updatedBy: { required: true },
        createdBy: { required: true },
    };
}

export class JobCompletedRequest {
    /**  */
    @Expose()
    "id": string;

    /**  */
    "result": string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["result"] = data["result"];
    }

    public static validationModel = {
        id: { required: true },
        result: { required: true },
    };
}

export class JobDetailedResponse {
    /**  */
    "data"?: Job;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class JobExceptionDetailedResponse {
    /**  */
    "data"?: JobExceptionStatusResponse;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class JobExceptionListDetailedResponse {
    /**  */
    "data"?: JobExceptionStatusResponse[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class JobExceptionStatusResponse {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "jobExcecutionID"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "createdDateTime": Date;

    /**  */
    "exception": string;

    /**  */
    "jobExecution": JobExecutionStatusResponse;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["jobExcecutionID"] = data["jobExcecutionID"];
        this["createdDateTime"] = data["createdDateTime"];
        this["exception"] = data["exception"];
        this["jobExecution"] = data["jobExecution"];
    }

    public static validationModel = {
        createdDateTime: { required: true },
        exception: { required: true },
        jobExecution: { required: true },
    };
}

export class JobExecutionDetailedResponse {
    /**  */
    "data"?: JobExecutionStatusResponse;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class JobExecutionListDetailedResponse {
    /**  */
    "data"?: JobExecutionStatusResponse[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class JobExecutionStatusResponse {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "jobID"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "startDateTime": Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "endDateTime"?: Date;

    /**  */
    "parameters": string;

    /**  */
    "result"?: string;

    /**  */
    "job": Job;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["jobID"] = data["jobID"];
        this["startDateTime"] = data["startDateTime"];
        this["endDateTime"] = data["endDateTime"];
        this["parameters"] = data["parameters"];
        this["result"] = data["result"];
        this["job"] = data["job"];
    }

    public static validationModel = {
        startDateTime: { required: true },
        parameters: { required: true },
        job: { required: true },
    };
}

export class JobListDetailedResponse {
    /**  */
    "data"?: Job[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class MutateJob {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    "sourceLocation"?: string;

    /**  */
    "hostedType"?: HostedTypeEnum;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["active"] = data["active"];
        this["sourceLocation"] = data["sourceLocation"];
        this["hostedType"] = data["hostedType"];
    }

    public static validationModel = {};
}

export class UpdateJobExceptionRequest {
    /**  */
    @Expose()
    "id": string;

    /**  */
    "exception": string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["exception"] = data["exception"];
    }

    public static validationModel = {
        id: { required: true },
        exception: { required: true },
    };
}

export type HostedTypeEnum = 1 | 2 | 3;
